import { Pipe } from '@angular/core';
import {format_time} from "../util";

@Pipe({name: 'ordertime', pure: true, standalone: false})
export class OrderTimePipe {
   transform(time: number): string {
       return format_time(time);
   }
}
